import { fetchSuccessWithoutTotal } from 'modules/browseSection/actions/fetch/data';

export const browseDependencies = ({ dispatch, browseData, value, section }) => {
	dispatch(fetchSuccessWithoutTotal({ ...browseData, rows: value })(section));
};
